var map = {
	"./findoctor/single-page/home": [
		"225e",
		"chunk-9497ea90",
		"chunk-61229b1c"
	],
	"./wedding/single-page/home": [
		"59b9",
		"chunk-9497ea90",
		"chunk-79a63248"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "01a8";
module.exports = webpackAsyncContext;